import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSportConfiguration } from "~hooks/useSportConfiguration.ts";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  defaultValue?: string | { value: string; label: string }[];
  placeholder?: string;
  multiple?: boolean;
  value?: LabelValue | LabelValue[];
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
  width?: number;
};

const SelectFixtureStatus = (props: Props) => {
  const { className, disabled, defaultValue, multiple } = props;
  const { fixtureStatuses } = useSportConfiguration();
  const { formatMessage } = useIntl();

  const options = useMemo(
    () =>
      fixtureStatuses.map((value) => ({
        value,
        label: formatMessage({ id: `fixtureStatus.${value}` }),
      })),
    [fixtureStatuses],
  );

  return (
    <CustomSelect
      style={{ minWidth: props.width || "130px" }}
      value={props.value}
      defaultValue={defaultValue}
      onChange={(_, option) => {
        if (multiple) {
          props.onChange?.(option as { value: string; label: string }[]);
        } else {
          props.onChange?.(option as { value: string; label: string });
        }
      }}
      options={options}
      placeholder={props.placeholder || <FormattedMessage id="status" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectFixtureStatus;
